export default function createSocketIoMiddleware(socket, criteria = [],
  { eventName = 'action', execute = defaultExecute } = {}) {
  const emitBound = socket.emit.bind(socket);
  return ({ dispatch }) => {

    socket.on(eventName, dispatch);
    return next => (action) => {
      if (evaluate(action, criteria)) {
        return execute(action, emitBound, next, dispatch);
      }
      return next(action);
    };
  };

  function evaluate(action, option) {
    if (!action || !action.type) {
      return false;
    }

    const { type } = action;

    if (typeof option === 'function') return option(type, action);
    else if (typeof option === 'string') return type.indexOf(option) === 0;
    else if (Array.isArray(option)) return option.some(item => type.indexOf(item) === 0);
    return false;
  }

  function defaultExecute(action, emit, next) {
    emit(eventName, action);
    return next(action);
  }
}



// WEBPACK FOOTER //
// ./src/redux/middleware/socket.js